<ng-container *ngIf="productReport"> 
    <div class="container pt--64 pb--64 pl--48 pr--48">
        <mat-card class="mat-elevation-z0 bg-sky bg-text-dark card-rounded rounded p--24">
            <mat-card-content>
                <div class="row m--0">
                    <div class="col-12 col-lg-6">
                        <h4 class="text-primary">Vuoi saperne ancora di pi&ugrave;?</h4>
                        <h1 class="h2">Il tuo Benchmark è pronto,<br/>Ottieni una versione completa.</h1>
                        <div class="text-default" translate>Il Benchmark personalizzato è un documento completo, ottenuto grazie all’analisi dei dati provenienti da fonti pubbliche e ufficiali (ISTAT, Cerved, sito ufficiale dell’azienda).</div>
                        <div class="product-pricing d-flex gap-8 align-items-center pt--24 pb--24" *ngIf="productReport">
                        <div class="text-strong">{{ productReport.name }} {{ 'a partire da' | translate }}</div><div class="h3 mb--0 text-strong">{{ productReport.price | currency:'EUR':'symbol':'1.0-0' }}</div>
                        </div>
                        <div class="promo-actions d-flex flex-column flex-lg-row gap-8 mb--16">
                            <button mat-stroked-button (click)="getDemo()" class="mt--24" color="primary" [disabled]="downloadingdemo" [ngClass]="{ 'downloading-animation': downloadingdemo }">{{ 'Scarica un esempio' | translate }} <span *ngIf="downloadingdemo" class="di di-download"></span></button>
                            <button mat-flat-button (click)="goToReport()" class="mt--24" color="primary"> {{ 'Scopri di più' | translate }}</button>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <img [ngSrc]="'/images/background/benchmark-devices.webp'" width="450" height="300" alt="Benchmark Devices" class="img-responsive rounded"/>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</ng-container>
<div class="container py--64 px--48">
    
<h2 class="mat-text-primary text-center mb--48">Scopri i modi in cui Delfi.ai guida la tua azienda verso il successo</h2>
    <ng-container *ngIf="layout == 'a'">
    <section class="products-promo">
        <app-section-title [titletag]="'Conosci il tuo business'"></app-section-title>
        <div class="row m--0">
            <div class="col-12 col-lg-6 p--0">
                <div class="fw products-accordion">
                    
                    <h3 class="product-section-title">{{ 'Massimizza i tuoi profitti' | translate}}</h3>
                    <!-- </mat-panel-title>
                        </mat-expansion-panel-header> -->
                    <p>Delfi.ai è in grado di analizzare e mettere in evidenza grandi quantità d’informazioni, per
                        raggiungere 3 obiettivi:</p>
                    <ul class="list-check-primary">
                        <li>
                            <div class="text-primary title-feature">Nuove opportunità</div>
                            <div class="text-default">L’analisi dei dati mette in evidenza i punti di miglioramento
                                e suggerisce le strade da percorrere per migliorare o ottimizzare i tuoi servizi e
                                il tuo business,</div>
                        </li>
                        <li>
                            <div class="text-primary title-feature">Decisioni basate sui dati</div>
                            <div class="text-default">Per ogni azienda è importante conoscere i propri punti di
                                debolezza, da qui si parte per un processo di miglioramento
                                per il proprio business e i propri profitti.</div>
                        </li>
                        <li>
                            <div class="text-primary title-feature">Analisi dei punti di debolezza</div>
                            <div class="text-default">Per ogni azienda è importante conoscere i propri punti di
                                debolezza, da qui si parte per un processo di miglioramento per il proprio business
                                e i propri profitti.</div>
                        </li>
                    </ul>
                    <button mat-stroked-button color="primary"  class="mb--24" (click)="goToReport()">Ottieni subito il tuo Benchmark
                        personalizzato</button>
                    <!-- </mat-expansion-panel> -->
                </div>
            </div>
            <div (click)="goToReport()" class="button-product active col-12 col-lg-6">
                <img [ngSrc]="'/images/products/promo-benchmark.webp'" width="582" height="388"
                    [attr.alt]="'products-overview'" class="img-responsive rounded" priority>
            </div>
        </div>
    </section>
    <mat-divider class="mt--32 mb--32"></mat-divider>
    </ng-container>
    <section class="products-promo">
        <app-section-title [titletag]="'L\'innovazione si sostiene'"></app-section-title>
        <div class="row m--0">
            <div class="col-12 col-lg-6 p--0">

                <!-- <mat-expansion-panel class="mat-elevation-z0 mb--0" (opened)="setActivePanel('marketplace')"
                        [expanded]="activePanel === 'products' ">
                        <mat-expansion-panel-header class="p--0">
                            <mat-panel-title> -->
                <h3 class="product-section-title">{{ 'Ottimizza le tue potenzialità' | translate}}</h3>
                <!-- </mat-panel-title>
                        </mat-expansion-panel-header> -->
                <p>I nostri prodotti digitali ti aiutano a lavorare sul tuo potenziale: </p>
                <ul class="list-check-primary">
                    <li>
                        <div class="text-primary title-feature">Prodotti digitali</div>
                        <div class="text-default">Piattaforme, gestionali, strumenti per ottimizzare e rendere digitali
                            i tuoi processi per non restare indietro rispetto ai competitor.</div>
                    </li>
                    <li>
                        <div class="text-primary title-feature">Innovazione in azienda</div>
                        <div class="text-default">Migliora la tua produttività, l’assistenza clienti, la gestione
                            magazzino, tool e app per agevolare il tuo business.</div>
                    </li>
                    <li>
                        <div class="text-primary title-feature">L’esperienza si fa app</div>
                        <div class="text-default">Le esperienze acquisite nelle Grandi Imprese diventano strumenti, app,
                            gestionali e servizi per rispondere anche alle necessità di piccole e medie imprese.</div>
                    </li>
                </ul>


                <button mat-stroked-button color="primary" (click)="goToMarketplace()" class="mb--24">{{ 'Get started' | translate }}</button>
            </div>

            <div (click)="getProductAction('marketplace')" class="button-product active col-12 col-lg-6">
                <img [ngSrc]="'/images/products/promo-prodotti.webp'" width="582" height="388"
                    [attr.alt]="'products-overview'" class="img-responsive rounded" priority>
            </div>
        </div>
    </section>
    <mat-divider class="mt--32 mb--32"></mat-divider>
    <section class="products-promo">
        <app-section-title [titletag]="'Soluzioni per il tuo business'"></app-section-title>
        <div class="row m--0">
            <div class="col-12 col-lg-6 p--0">
                <!-- </mat-expansion-panel>
                    <mat-expansion-panel class="mat-elevation-z0 mb--0" (opened)="setActivePanel('services')"
                        [expanded]="activePanel === 'services' ">
                        <mat-expansion-panel-header class="p--0">
                            <mat-panel-title> -->
                <h3 class="product-section-title">{{ 'Ottieni vantaggi fiscali' | translate}}</h3>
                <!-- </mat-panel-title>
                        </mat-expansion-panel-header> -->
                <p>I piani di miglioramento richiedono tempo e risorse da investire, le imprese possono accedere a
                    diversi vantaggi fiscali per proseguire il loro piano d’azione, consulta le leve fiscali
                    disponibili:</p>
                <ul class="list-check-primary">
                    <li>
                        <div class="text-primary title-feature">Bonus fiscali</div>
                        <div class="text-default">Scopri le agevolazioni che potresti ottenere per risparmiare e
                            migliorare la tua azienda.</div>
                    </li>
                    <li>
                        <div class="text-primary title-feature">Accesso ai Bandi</div>
                        <div class="text-default">Accedi a uno o più bandi disponibili per realizzare il tuo percorso di
                            miglioramento o affrontare nuove sfide aziendali.</div>
                    </li>
                    <li>
                        <div class="text-primary title-feature">Consulenza integrata</div>
                        <div class="text-default">Richiedi la consulenza personalizzata da un team di esperti pronti ad
                            aiutarti ad ottenere il massimo dai piani di miglioramento e dai possibili incentivi, bonus
                            o bandi che possono aiutare il tuo business.</div>
                    </li>
                </ul>
                <button mat-stroked-button color="primary" (click)="goToMarketplace()"  class="mb--24">{{ 'Get started' | translate }}</button>
                <!-- </mat-expansion-panel> -->
                <!-- </mat-accordion> -->
            </div>
            <div (click)="getProductAction('services')" class="button-product active col-12 col-lg-6">
                <img [ngSrc]="'/images/products/promo-servizi.webp'" width="582" height="388"
                    [attr.alt]="'products-overview'" class="img-responsive rounded" priority>
            </div>
        </div>
    </section>
</div>
<!-- </div> -->
<!-- <div class="col-12 col-lg-6 column m--0 justify-content-start align-items-start">
    <div (click)="getProductAction('report')" [ngClass]="{'active': activePanel == 'report'}" class="button-product ">
        <img [ngSrc]="'/images/products/promo-report.svg'" width="650" height="388" [attr.alt]="'products-overview'"
            class="img-fluid " priority>
    </div>
    <div (click)="getProductAction('marketplace')" [ngClass]="{'active': activePanel == 'marketplace'}"
        class="button-product ">
        <img [ngSrc]="'/images/products/promo-marker.svg'" width="650" height="388" [attr.alt]="'products-overview'"
            class="img-fluid absolute" priority>
    </div>
    <div (click)="getProductAction('services')" [ngClass]="{'active': activePanel == 'services'}"
        class="button-product ">
        <img [ngSrc]="'/images/products/promo-services.svg'" width="650" height="388" [attr.alt]="'products-overview'"
            class="img-fluid absolute" priority>
    </div>
</div> -->
<!-- </div>
</div> -->